import React from 'react';
import { Tooltip } from '@material-ui/core';
import { NavLink } from 'react-router-dom';

export function MiniCard({ title, body, footer, to, onClick }) {
  return to ? (
    <NavLink
      className="d-flex flex-column cursor-pointer"
      to={to}
      activeClassName="areas-bg-grey"
      style={{ borderBottom: 'solid 1px #AAAAAA' }}
    >
      <div className="col-12 my-1 area-card name">
        <Tooltip arrow position="top" title={title}>
          <h6 className="font-weight-bolder mb-0">{title}</h6>
        </Tooltip>
      </div>
      <div className="col-12 my-1 area-card description">
        <Tooltip arrow position="top" title={body}>
          <span className="dark-grey">{body}</span>
        </Tooltip>
      </div>
      <div className="col-12 my-1 area-card footer-card">
        <Tooltip arrow position="top" title={footer}>
          <span>{footer}</span>
        </Tooltip>
      </div>
    </NavLink>
  ) : (
    <span
      className="d-flex flex-column cursor-pointer"
      onClick={onClick}
      style={{ borderBottom: 'solid 1px #AAAAAA' }}
    >
      <div className="col-12 my-1 area-card name">
        <Tooltip arrow position="top" title={title}>
          <h6 className="font-weight-bolder mb-0">{title}</h6>
        </Tooltip>
      </div>
      <div className="col-12 my-1 area-card description">
        <Tooltip arrow position="top" title={body}>
          <span className="dark-grey">{body}</span>
        </Tooltip>
      </div>
      <div className="col-12 my-1 area-card footer-card">
        <Tooltip arrow position="top" title={footer}>
          <span>{footer}</span>
        </Tooltip>
      </div>
    </span>
  );
}
